var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.936 10.403v3.295h7.802v-3.295H6.936zM25.315 10.403v3.295h7.803v-3.295h-7.803zM6.936 15.952v3.294h7.802v-3.294H6.936zM6.936 21.5v3.295h4.508V21.5H6.936zM25.315 15.952v3.294h4.508v-3.294h-4.508zM25.315 21.5v3.295h7.803V21.5h-7.803z",
    fill: "#5700FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26.98V0h15.164a6.388 6.388 0 014.798 2.18A6.388 6.388 0 0124.76 0h15.164v26.98c0 6.156-5.009 11.166-11.166 11.166h-7.084v-3.19h7.084c4.398 0 7.976-3.579 7.976-7.977V3.19H24.76a3.194 3.194 0 00-3.19 3.19v1.596h-.025v19.073h.025c0 6.136-5.01 11.128-11.167 11.128v-.057C4.601 37.726 0 32.88 0 26.98zm18.356.242h.021c-.087 4.048-3.226 7.361-7.21 7.74v-.007c-4.399 0-7.977-3.578-7.977-7.976V3.19h11.974a3.194 3.194 0 013.19 3.19l.002 20.842z",
    fill: "#5700FF"
  })));
}
export default SvgBookPurple;